module.exports = __webpack_public_path__ + "static/media/B3.3f764dc4.svg";